export const SIZE = 20;
export const LETTERS = "abcdefghijklmnopqrstuvwxyz".split("");
export const INITIAL_SPEED = 500;
export const SPEED_INCREMENT = 25;
